import React from 'react'
import '../../assets/css/PrintFoodsComponent.css';

export const PrintFoodsComponent = ({ foods }) => {

  // محاسبه مجموع تعداد
  const totalCount = foods.reduce((sum, food) => sum + food.count, 0);


  return (
    <>
      <div className="table-container">

        <table className="food-table">
          <thead>
            <tr>
              <th>ردیف</th>
              <th>شماره میز</th>
              <th>روز هفته</th>
              <th>وعده</th>
              <th>عنوان غذا</th>
              <th>تعداد</th>
              <th>تاریخ</th>
            </tr>
          </thead>
          <tbody>
            {foods.map((food, index) => (
              <tr key={food.id}>
                <td>{index + 1}</td>
                <td></td>
                <td>{food.dayOfWeek}</td>
                <td>{food.persionFoodSection}</td>
                <td>{food.foodTitle}</td>
                <td>{food.count}</td>
                <td>{food.date_Shamsi}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="4"></td>
              <td>جمع کل</td>
              <td>{totalCount}</td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
<br/>
      <div className="table-container">
        <table className="food-table">
          <thead>
            <tr>
              <th>مهر و امضا پذیرش</th>
              <th>امضا تحویل گیرنده</th>
              <th>امضا تحویل دهنده</th>
            </tr>
          </thead>
          <tbody>
              <tr >
                <td><br/><br/></td>
                <td><br/><br/></td>
                <td><br/><br/></td>
               </tr>
          </tbody>
        </table>
      </div>
<br/>

    </>
  )
}